import React, { useEffect } from "react";

const UPDATED_AT = "14 de Setembro de 2025";

export default function PoliticaCookies() {
  useEffect(() => {
    document.title = "Política de Cookies | Luciana Costa";
  }, []);

  return (
    <main className="container py-4" style={{ maxWidth: 900 }}>
      <h1 className="h3 fw-bold mb-3">Política de Cookies</h1>
      <p className="text-muted mb-4">
        Última atualização: <time dateTime="2025-09-14">{UPDATED_AT}</time>
      </p>

      <article className="lh-base" style={{ whiteSpace: "normal" }}>
        <p className="bg-light border rounded p-3">
          Esta Política explica o que são cookies, como são utilizados no site{" "}
          <a href="https://lucianacosta.cv">lucianacosta.cv</a> e como podes
          gerir as tuas preferências. O objetivo é garantir transparência e
          conformidade com o Regulamento Geral de Proteção de Dados (RGPD).
        </p>

        <h2 className="h6 fw-semibold mt-4">1) O que são cookies?</h2>
        <p>
          Cookies são pequenos ficheiros de texto armazenados no teu
          dispositivo (computador, telemóvel, tablet) quando visitas um site.
          Servem para melhorar a experiência de navegação e recolher informações
          anónimas sobre o uso do site.
        </p>

        <h2 className="h6 fw-semibold mt-4">2) Tipos de cookies utilizados</h2>
        <ul>
          <li>
            <strong>Cookies essenciais:</strong> necessários para o
            funcionamento básico do site (ex.: autenticação, carrinho de compras).
          </li>
          <li>
            <strong>Cookies de desempenho e análise:</strong> ajudam-nos a
            compreender como os visitantes interagem com o site, permitindo
            melhorar o conteúdo e a usabilidade. Exemplo: Google Analytics.
          </li>
          <li>
            <strong>Cookies de funcionalidade:</strong> permitem guardar
            preferências (ex.: idioma, sessão iniciada).
          </li>
        </ul>

        <h2 className="h6 fw-semibold mt-4">3) Cookies de terceiros</h2>
        <p>
          Alguns cookies são definidos por serviços externos que integramos no
          site, como Google, Stripe, PayPal ou YouTube. Estes serviços têm as
          suas próprias políticas de privacidade e cookies, disponíveis nos
          respetivos sites oficiais.
        </p>

        <h2 className="h6 fw-semibold mt-4">4) Gestão e controlo de cookies</h2>
        <p>
          Podes gerir ou eliminar cookies a qualquer momento através das
          definições do teu navegador. A maioria dos browsers permite bloquear
          cookies ou receber um aviso antes de os aceitar.  
          No entanto, ao desativar certos cookies, algumas funcionalidades do
          site podem deixar de funcionar corretamente.
        </p>

        <ul>
          <li>
            <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">
              Gerir cookies no Google Chrome
            </a>
          </li>
          <li>
            <a href="https://support.mozilla.org/pt-PT/kb/ativar-desativar-cookies" target="_blank" rel="noopener noreferrer">
              Gerir cookies no Mozilla Firefox
            </a>
          </li>
          <li>
            <a href="https://support.apple.com/pt-pt/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">
              Gerir cookies no Safari
            </a>
          </li>
        </ul>

        <h2 className="h6 fw-semibold mt-4">5) Consentimento</h2>
        <p>
          Ao visitar o site pela primeira vez, será apresentado um banner de
          consentimento para escolher as tuas preferências.  
          Podes alterá-las a qualquer momento nas definições de cookies do
          navegador ou na área de privacidade do site.
        </p>

        <h2 className="h6 fw-semibold mt-4">6) Alterações a esta política</h2>
        <p>
          Podemos atualizar esta Política de Cookies para refletir alterações na
          legislação ou nas práticas internas. A versão publicada no site
          substitui as anteriores.
        </p>

        <hr className="my-4" />
        <p className="small text-muted">
          Para mais informações, consulta a nossa{" "}
          <a href="/politica-de-privacidade">Política de Privacidade</a> ou
          contacta-nos:{" "}
          <a href="mailto:info@lucianacosta.cv">info@lucianacosta.cv</a>.
        </p>
      </article>
    </main>
  );
}
